import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

export const usePDActiveSubscription = (productFilter = null) => {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();

    const userId = authState?.user?._id;
    const token = authState?.token;

    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const [product, setProduct] = useState(null);
    const [loadingSubs, setLoadingSubs] = useState(false);
    const hasFetchedSubsRef = useRef(false);

    // Importatnt - Response payload by the endpoint : "_id product subscriptionId startDate endDate isActive"

    const fetchMySubs = async () => {
        if (!userId || !token) return;

        try {
            setLoadingSubs(true);
            const config = {
                url: "/pd/subscription/my/status-any",
                method: "post",
                data: { userId },
                headers: { Authorization: token },
            };

            const response = await fetchData(config, { silent: true });

            if (response?.status) {
                const subs = response.data || [];
                setSubscriptions(subs);
                if (subs.length > 0) {
                    const today = new Date();

                    const filteredSubs = productFilter
                        ? subs.filter(sub => sub.product === productFilter)
                        : subs;

                    const activeSub =
                        filteredSubs.find(sub =>
                            sub.isActive || new Date(sub.endDate) >= today
                        ) ||
                        filteredSubs[0] ||
                        null;

                    setSelectedSubscription(activeSub);
                    setProduct(activeSub?.product || null);
                }
                hasFetchedSubsRef.current = true;
            }
        } catch (error) {
            console.error("Fetch Subscription Error:", error);
        } finally {
            setLoadingSubs(false);
        }
    };

    // Fetch on mount when userId is available
    useEffect(() => {
        if (userId && !hasFetchedSubsRef.current) {
            fetchMySubs();
        }
    }, [userId]);

    const isExpired = selectedSubscription?.endDate 
        ? new Date(selectedSubscription.endDate) < new Date() 
        : false;

    const isActive = selectedSubscription?.isActive && !isExpired;

    const daysLeft = selectedSubscription?.endDate 
        ? Math.ceil((new Date(selectedSubscription.endDate) - new Date()) / (1000 * 3600 * 24))
        : null;

    const formatRange = (sub) => {
        if (!sub) return "";
        return `${sub.subscriptionId} (${new Date(sub.startDate).toLocaleDateString()} → ${new Date(sub.endDate).toLocaleDateString()})`;
    };

    return {
        subscriptions,
        selectedSubscription,
        setSelectedSubscription,
        loadingSubs,
        isActive,
        product,
        isExpired,
        daysLeft,
        formatRange,
        refetch: fetchMySubs,           // useful to refresh manually
    };
};